<template>
    <div class="header_top">
        <div class="index_title_top">
            <div class="top_content_menu">
                <div class="menu_left">
                    <div class="item_menu" @click="gohome">商城首页</div>
                    <!-- <div class="item_menu">上传Excel表格批量下单</div>
                    <div class="item_menu">批量下单模板下载</div>
                    <div class="item_menu">下载中心</div> -->
                </div>
                <div style="width: 600px;"></div>
                <div class="menu_right">
                    <div class="item_menu" v-if="userInfo.mobile">{{ userInfo.mobile }}</div>
                    <div v-else class="item_menu" @click="$router.replace('/login/signIn')">请登录</div>
                    <!-- <div class="item_menu">待付款订单(9)</div> -->
                    <!-- <div class="item_menu my_goods_order">
                        <el-dropdown>
                            <el-button class="drow_button">
                                <i class="iconfont icon-gouwugouwuchedinggou"></i>
                                我的进货单(0)
                            </el-button>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item>
                                    <div class="stock_goods">
                                        <span>12132</span>
                                    </div>
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div> -->
                    <div class="item_menu user_menu">
                        <el-dropdown @command="goMyuser" style="width: 100%;height: 100%;">
                            <el-button class="drow_button">
                                个人中心<i class="el-icon-arrow-down el-icon--right"></i>
                            </el-button>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item command="/personcenter/account/account">我的订单</el-dropdown-item>
                                <el-dropdown-item command="/personcenter/personcenter/applykey">API货盘对接</el-dropdown-item>
                                <el-dropdown-item command="/personcenter/personcenter/balance">我的钱包</el-dropdown-item>
                                <el-dropdown-item command="/personcenter/personcenter/selectionlibrary">我的选品库</el-dropdown-item>
                                <!-- <el-dropdown-item command="selectionlibrary">我的选品库</el-dropdown-item> -->
                                <!-- <el-dropdown-item>我的足迹</el-dropdown-item> -->
                                <!-- <el-dropdown-item>报销专款</el-dropdown-item> -->
                                <!-- <el-dropdown-item command="/personcenter/authentication">企业账号管理</el-dropdown-item> -->
                                <!-- <el-dropdown-item>收货地址管理</el-dropdown-item> -->
                                <el-dropdown-item command="/personcenter/personcenter/editpassword">修改密码</el-dropdown-item>
                                <el-dropdown-item command="logout">退出登录</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>

                    </div>
                    <!-- <div class="item_menu">联系客服</div> -->
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {

    data() {
        return {
            userInfo: {}
        }
    },
    props: ['activeName'],
    created() {

    },
    mounted() {
        this.getUserinfo()
    },
    computed: {

    },
    methods: {
        getUserinfo() {
            const token = localStorage.getItem("kstoken")
            if (token) {
                this.$http.get("/user/index").then(res => {
                    if (res.code === 1) {
                        this.userInfo = res.data
                        this.$store.commit("user/setUserInfo", res.data)
                    }

                })
            }
        },



        goMyuser(e) {
            if (e === "logout") {
                this.$confirm("确认要退出登录吗?", "提示", {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    center: true
                }).then(res => {
                    this.$http.post("/user/logout").then(res => {
                        if (res.code === 1) {
                            this.$message({
                                type: 'success',
                                message: res.msg
                            });
                            localStorage.removeItem('token')
                            setTimeout(() => {
                                this.$router.replace('/login/signIn')
                            }, 1000);
                        }
                    })
                }).catch(res => {
                    this.$message({
                        type: 'info',
                        message: '取消'
                    });
                })
            } else if (e === '/personcenter/personcenter/selectionlibrary') {
                this.$router.push({
                    name: 'selectionlibrary',
                    query: {
                      activeName: this.activeName
                    }
                });
                this.$emit("routerChange", e)
            } else {
                this.$router.push(e)
                this.$emit("routerChange", e)
            }

        },
        gohome() {
            this.$router.push('/')
        },
    }
};
</script>
  
<style scoped lang="scss">
* {
    box-sizing: border-box;
}

.index_title_top {
    height: 46px;
    background-color: #efefef;

    .top_content_menu {
        width: 1200px;
        margin: 0 auto;
        display: flex;
        height: 100%;
    }

    .menu_left,
    .menu_right {
        flex: 1;
        display: flex;
    }

    .menu_right {
        position: relative;
    }



    .item_menu {
        flex: 1;
        text-align: center;
        font-size: 12px;
        line-height: 46px;
        cursor: pointer;
    }

    .item_menu:hover {
        color: #da1f34;
    }

    .drow_button {
        color: #000;
        border: none !important;
        background-color: transparent !important;
        padding: 0 2px;
        width: 100%;
        height: 100%;
    }

    .my_goods_order {
        display: flex;
        justify-content: space-around;
        padding: 0 10px;













    }

    .user_menu:hover,
    .my_goods_order:hover {
        color: #fff !important;
        background-color: #da1f34;

        .drow_button {
            background-color: #da1f34 !important;
            color: #fff !important;
        }

    }

    .arrow_down {
        display: inline-block;
        width: 20px;
        height: 10px;
        background-image: url('../../../static/img/shopcar_2.png');
        background-size: contain;
        background-repeat: no-repeat;
    }

    .cart_icon {
        display: inline-block;
        width: 14px;
        height: 12px;
        background-image: url('../../../static/img/shopcar_1.png');
        background-size: contain;
        background-repeat: no-repeat;
    }
}


.index_title_top_2 {
    height: 46px;
    background-color: #fff;
    border-bottom: 1px solid #ccc;

    .top_content_menu {
        display: flex;
        justify-content: space-around;
        padding: 12px 100px;
        font-size: 14px;
    }

}

.index_title_top_3 {
    box-sizing: border-box;
    height: 103px;
    background-color: #fff;
    padding: 30px 0;

    .logo_input {
        width: 1200px;
        margin: 0 auto;
        display: flex;
    }

    .logo {
        width: 180px;
        height: 40px;
    }

    .input_box {
        border: 1px solid #fd2632;
        border-top-left-radius: 6px;
        border-bottom-left-radius: 6px;
        padding: 0 16px;
        width: 558px;
        height: 40px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
    }

    .my_carts {
        border: 1px solid #fd2632;
        border-radius: 6px;
        padding: 11px 38px;
        margin-left: 20px;
        cursor: pointer;
        position: relative;
        font-size: 14px;
        color: #fd2632;

        .cart_num {
            position: absolute;
            right: -5px;
            top: -8px;
            font-size: 12px;
            padding: 0 2px;
            border-radius: 20px;
            background-color: #fd2632;
            color: #fff;
            font-size: 12px;
        }
    }

    .input_item {
        border: none !important;
        height: 100%;
    }

    .input_item:focus {
        outline: none;
    }

    .search-btn {
        background-color: #fd2632;
        border-top-right-radius: 6px;
        border-bottom-right-radius: 6px;
        height: 40px;
        padding: 0 32px;
        cursor: pointer;
        line-height: 40px;
        color: #fff;
    }
}


.left_menu {
    box-sizing: border-box;
    color: #000;
    width: 220px;
    height: 272px;
    overflow: auto;
    background-color: #fff;
    border-radius: 5px;
    margin-right: 10px;
    padding: 10px;

    .item_li {
        box-sizing: border-box;
        width: 215px;
        height: 41px;
        padding: 11px 14px;
        display: flex;
        justify-content: space-between;
    }
}

.right_top {

    width: 234px;
    height: 110px;
    padding: 20px 14px 6px;
    border-radius: 5rpx;
    background-color: #fff;
    margin-left: 10px;

    .top,
    .bottom {
        display: flex;
    }

    .item_menu {
        flex: 1;
        height: 28px;
        margin-bottom: 14px;
        cursor: pointer;
    }

}

.right_bottom {
    width: 234px;
    height: 148px;
    margin-top: 14px;
    padding: 15px 14px;
    border-radius: 5px;
    background-color: #fff;
    margin-left: 10px;

    .item_li {
        height: 31px;
        border: 1px solid #d3b582;
        border-radius: 5px;
        padding: 5px 0;
        text-align: center;
        margin-bottom: 12px;
        color: #ae8c51;
    }
}

.goods_gift {
    width: 1200px;
    height: 375px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;

    .goods_left,
    .goods_right {
        flex: 0 0 48%;
        min-height: 100%;
        background-color: #fff;
        border-radius: 5px;
        padding: 20px;
    }

    .item_name {
        display: flex;
        justify-content: space-between;
        margin-bottom: 15px;
        font-size: 22px;
    }

    .goods_content {
        display: flex;
        justify-content: space-between;
    }

    .item_goods {
        flex: 0 0 32%;
        background-color: tan;
        min-height: 280px;
        border-radius: 8px;
        overflow: hidden;
        padding-bottom: 10px;
    }

    .goods_img {
        width: 100%;
        height: 190px;
    }

    .goods_name {
        padding: 5px 10px;
        font-size: 14px;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        height: 40px;
        margin-bottom: 10px;
    }

    .goods_desc {
        font-size: 14px;
        padding: 0 10px;
    }

}

.goods_class_1 {
    box-sizing: border-box;
    width: 1200px;
    margin: 20px auto;
    min-height: 350px;
    background-color: #fff;
    border-radius: 8px;
    padding: 16px 0 0;
    position: relative;

    .title_name {
        display: flex;
        justify-content: space-between;
        padding: 0 24px;
    }

    .class_name {
        font-size: 22px;
    }

    .class_info {
        font-size: 15px;
    }

    .title_right .more {
        color: #999;
        font-size: 14px;
    }

    .arrow_right {
        border: 1px solid #999;
        border-radius: 50%;
    }


    .prev,
    .next {
        position: absolute;
    }

    .prev {
        left: 24px;
        top: 50%;
        transform: translateY(-50%);
        font-size: 36px;
    }

    .next {
        right: 24px;
        top: 50%;
        transform: translateY(-50%);
        font-size: 36px;
    }

    .list_box {
        width: 100%;
        overflow: hidden;
        height: 300px;
        position: relative;
        margin: 20px 0 0;
    }


    .goods_item_box {
        width: 200px;
        height: 300px;
        margin-right: 5px;
        background-color: darkkhaki;
        font-size: 14px;

    }
}

.el-carousel__item h3 {
    color: #475669;
    font-size: 18px;
    opacity: 0.75;
    line-height: 300px;
}

.el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
}

/deep/ .el-carousel__indicators {
    display: none !important;
}



.footer_goods_area {
    width: 1200px;
    margin: 40px auto;
    min-height: 200px;



    .recommend {
        width: 206px;
        height: 30px;
        margin: 0 auto;
        background-repeat: no-repeat;
        background-size: contain;
        background-image: url('../../../static/img/title_2.png');
    }

    .cate_box {
        display: flex;
        justify-content: space-around;
        margin-top: 30px;
        background-color: #fff;
        padding: 20px 0;
    }

    .item_cate {
        padding: 3px 15px;
        border-radius: 40px;
        color: #000;
    }

    .active_cate {
        padding: 3px 15px;
        border-radius: 40px;
        background-color: #ff2e2d;
        color: #fff;
    }

    .all_goods_box {
        margin-top: 40px;
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
    }

    .item_goods_box {
        width: calc((100% - 4 * 20px) / 5);
        margin-right: 20px;
        min-height: 300px;
        background-color: #fff;
        margin-bottom: 20px;
        padding: 20px;
        border-radius: 8px;
    }

    .item_goods_box:nth-child(5n) {
        margin-right: 0 !important;
    }

    .item_goods_image_box {
        width: 100%;
        height: 200px;

        img {
            width: 100%;
            height: 100%;
            border-radius: 5px;
        }
    }


    .goods_name_item {
        font-size: 14px;
        display: flex;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        /* 控制行数 */
        -webkit-box-orient: vertical;
        /* 垂直方向排列文本 */
        overflow: hidden;
        text-overflow: ellipsis;
        margin-top: 8px;
    }

    .goods_code {
        font-size: 12px;
        margin-top: 2px;
    }

    .goods_price {
        display: flex;
        font-size: 14px;
    }

    .jd_img,
    .vip_img {
        width: 42px;
        height: 14px;
        margin-left: 8px;
        background-size: contain;
        background-repeat: no-repeat;
        margin-top: 2px;
    }

    .jd_img {
        background-image: url('../../../static/tag_jd.png');
    }

    .vip_img {
        background-image: url('../../../static/tag_vip.png');
    }







}

#load_more {
    width: 1200px;
    margin: 30px auto;
    font-size: 14px;
    text-align: center;
    color: #666;
}
</style>

  


// WEBPACK FOOTER //
// src/components/headglobal/headglobal.vue